import { createAction, props } from '@ngrx/store';
import { UserFboLocationsDto } from 'src/app/api/administration/models/user-fbo-locations-dto';
import { CreateFboLocationRequestDto } from 'src/app/api/administration/models/create-fbo-location-request-dto';
import { UpdateFboLocationRequestDto } from 'src/app/api/administration/models/update-fbo-location-request-dto';
import { FboLocationDto } from 'src/app/api/administration/models/fbo-location-dto';

export const loadFboLocations = createAction('[FBO Locations] Load FBO Locations');

export const loadFboLocationsSuccess = createAction(
  '[FBO Locations] Load FBO Locations Success',
  props<{ locations: UserFboLocationsDto[] }>()
);

export const loadFboLocationsFailure = createAction(
  '[FBO Locations] Load FBO Locations Failure',
  props<{ error: string }>()
);

export const loadAllFboLocations = createAction(
  '[FBO Locations] Load All FBO Locations',
  props<{ params: { page: number; size: number; search?: string; sort?: string } }>()
);

export const loadAllFboLocationsSuccess = createAction(
  '[FBO Locations] Load All FBO Locations Success',
  props<{ locations: UserFboLocationsDto[]; totalRecords: number }>()
);

export const loadAllFboLocationsFailure = createAction(
  '[FBO Locations] Load All FBO Locations Failure',
  props<{ error: string }>()
);

export const createFboLocation = createAction(
  '[FBO Locations] Create FBO Location',
  props<{ fboLocation: CreateFboLocationRequestDto }>()
);

export const createFboLocationSuccess = createAction(
  '[FBO Locations] Create FBO Location Success',
  props<{ location: UserFboLocationsDto }>()
);

export const createFboLocationFailure = createAction(
  '[FBO Locations] Create FBO Location Failure',
  props<{ error: string }>()
);

export const getFboLocationDetails = createAction(
  '[FBO Locations] Get FBO Location Details',
  props<{ locationId: number }>()
);

export const getFboLocationDetailsSuccess = createAction(
  '[FBO Locations] Get FBO Location Details Success',
  props<{ location: FboLocationDto }>()
);

export const getFboLocationDetailsFailure = createAction(
  '[FBO Locations] Get FBO Location Details Failure',
  props<{ error: string }>()
);

export const updateFboLocation = createAction(
  '[FBO Locations] Update FBO Location',
  props<{ locationId: number; fboLocation: UpdateFboLocationRequestDto }>()
);

export const updateFboLocationSuccess = createAction(
  '[FBO Locations] Update FBO Location Success',
  props<{ location: UserFboLocationsDto }>()
);

export const updateFboLocationFailure = createAction(
  '[FBO Locations] Update FBO Location Failure',
  props<{ error: string }>()
);

export const deleteFboLocation = createAction(
  '[FBO Locations] Delete FBO Location',
  props<{ locationId: number }>()
);

export const deleteFboLocationSuccess = createAction(
  '[FBO Locations] Delete FBO Location Success',
  props<{ locationId: number }>()
);

export const deleteFboLocationFailure = createAction(
  '[FBO Locations] Delete FBO Location Failure',
  props<{ error: string }>()
);

export const switchFboLocation = createAction(
  '[FBO Locations] Switch FBO Location',
  props<{ locationId: number }>()
);

export const switchFboLocationSuccess = createAction(
  '[FBO Locations] Switch FBO Location Success',
  props<{ selectedLocation: UserFboLocationsDto }>()
);

export const switchFboLocationFailure = createAction(
  '[FBO Locations] Switch FBO Location Failure',
  props<{ error: string }>()
);

export const resetFboLocationsState = createAction('[FBO Locations] Reset State');
